// src/components/KMSalesDeliveryDockets.tsx
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Utility functions (migrated from EL_Functions.js)
const gfn_ShowMessage = (message: string, type: string = 'A'): void => {
  if (message) {
    if (type === 'E') {
      console.error('Error:', message);
    }
    alert(message);
  }
};

const gfn_ClosePopup = (): void => {
  if (window.opener) {
    window.close();
  } else {
    window.history.back();
  }
};

const gfn_SetPopupReturn = (value: string): void => {
  if (window.opener) {
    window.opener.postMessage({
      type: 'popupReturn',
      value: value
    }, '*');
  }
};

const gfn_GetClientWidth = (): number => {
  return document.documentElement.clientWidth || document.body.clientWidth;
};

const KMSalesDeliveryDockets: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // State for all data (migrated from VB variables)
  const [data, setData] = useState<any>({
    orderRef: '',
    strFax: '',
    errorMsg: '',
    sGrid: '',
    pGrid: '',
    strName: '',
    strAddress: '',
    strPostCod: '',
    strState: '',
    state: '',
    areacode: '',
    email: '',
    strAreaCod: '',
    strPhone: '',
    instAMPM: '',
    instDate: '',
    instTime: '',
    capCity: '',
    firstName: '',
    descriptionName: '',
    startLevel: '',
    mobPhNo: '',
    login: '',
    schoolCode: '',
    countryCode: '',
    familyCode: '',
    ddCode: '',
    tradingName: '',
    phone: '',
    fax: '',
    abnNo: '',
    dAddr1: '',
    dAddr2: '',
    loginId: '',
    password: '',
    students: [],
    packages: [],
    hardLocks: [],
    mathsVouchers: { count: '', code: '' },
    maxCount: 1,
    gridRowCnt: 0,
    installationCompleted: false,
    trainingProvided: false,
    understandsUpload: false,
    comments: '',
    installerSignature: '',
    customerSignature: '',
    installerName: '',
    customerName: ''
  });

  const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;


  // Refs for DOM elements (migrated from VB)
  const divPrintRef = useRef<HTMLDivElement>(null);
  const tdImageRef = useRef<HTMLTableCellElement>(null);
  const tdTradNameRef = useRef<HTMLTableCellElement>(null);
  const tdUIdPswdRef = useRef<HTMLTableCellElement>(null);
  const tdHardLocksRef = useRef<HTMLTableCellElement>(null);
  const tblCustomerRef = useRef<HTMLTableElement>(null);
  const tdInstDatRef = useRef<HTMLTableCellElement>(null);
  const SP_divScrollableTableRef = useRef<HTMLDivElement>(null);

  // Load data (migrated from VB's Page_Load and LoadForm)
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get parameters from URL (simulating VB's Request.QueryString)
        const searchParams = new URLSearchParams(location.search);
        const login = searchParams.get('Login') || 'arjunap';
        const schoolCode = searchParams.get('SchoolCode') || 'FAMILY_AU';
        const ddCode = searchParams.get('DDCode') || '16292';
        const countryCode = searchParams.get('CountryCode') || '7';

        // In a real app, you would fetch this from your API
        const response = await fetch(`${API_BASE_URL}api/nskmapi/delivery-dockets/?DDCode=${ddCode}&Login=${login}&SchoolCode=${schoolCode}&CountryCode=${countryCode}`);

        if (!response.ok) throw new Error('Failed to load delivery docket');

        const result = await response.json();
        if (result.success) {
          setData(result.data);

          // Initialize all the VB functions after data is loaded
          setTimeout(() => {
            fn_Images();
            fn_TrdName();
            fn_showDet();
            fn_MaxCount();
            fn_HardLocks();
            fn_tblCustHt();
            fn_SetGridSize();
          }, 100);
        } else {
          gfn_ShowMessage(result.error || 'Failed to load delivery docket', 'E');
        }
      } catch (err) {
        gfn_ShowMessage(err instanceof Error ? err.message : 'An error occurred', 'E');
      }
    };

    fetchData();
  }, [location.search]);

  // Migrated from VB: fn_Images
  const fn_Images = () => {
    if (tdImageRef.current) {
      let imageSrc = '';
      switch (data.countryCode) {
        case '4':
          imageSrc = '/Images/EduLogo.gif';
          break;
        case '6':
          imageSrc = '/Images/KELogo_new.jpg';
          break;
        case '7':
          imageSrc = '/Images/academyone_logo.png';
          break;
        default:
          imageSrc = '/Images/kinetic.jpg';
      }
      tdImageRef.current.innerHTML = `<br /><img alt='' src='${imageSrc}' style='max-width: 100%;' />`;
    }
  };

  // Migrated from VB: fn_TrdName
  const fn_TrdName = () => {
    if (tdTradNameRef.current) {
      let html = '';
      switch (data.countryCode) {
        case '6':
          html = `<br />${data.tradingName}<br /> VAT Regn.: <br />`;
          break;
        case '7':
          html = `<br /><b>${data.tradingName}</b><br />${data.dAddr1}<br />${data.dAddr2}<br /> Ph: ${data.phone}<br /> Fax: ${data.fax}<br />`;
          break;
        default:
          html = `<br />${data.tradingName}<br /> ABN: ${data.abnNo}<br />${data.dAddr1}<br />${data.dAddr2}<br /> Ph: ${data.phone}<br />`;
      }

      if (data.countryCode === '1') {
        html += `<br />Authorised distributor of <br /> the Maths Wiz <br /> and English Wiz products`;
      }

      tdTradNameRef.current.innerHTML = html;
    }
  };

  // Migrated from VB: fn_showDet
  const fn_showDet = () => {
    if (tdUIdPswdRef.current) {
      let html = '';
      switch (data.countryCode) {
        case '1':
          html = `<br /><b>Kinetic Education's online study club</b><br /><i><u>www.yourlearningadvantage.com</u></i><br /><i><u>www.mathsdoctor.com.au</u></i>`;
          break;
        case '6':
          html = `<br /><b>Kinetic Education's online study club</b><br /><i><u>www.yourlearningadvantage.co.uk</u></i>`;
          break;
        case '7':
          html = '';
          break;
        default:
          html = `<br /><b>EducationNOW's online study club</b><br /><i><u>www.educationnow.co.uk</u></i>`;
      }

      html += `<p><b>UserName: </b>${data.loginId}<br /><p><b>Password: </b>${data.password}</p>`;
      tdUIdPswdRef.current.innerHTML = html;
    }
  };

  // Migrated from VB: fn_MaxCount
  const fn_MaxCount = () => {
    if (data.maxCount === 1) {
      const trShwRow1 = document.getElementById('trShwRow1');
      const trShwRow2 = document.getElementById('trShwRow2');
      const trShwRow3 = document.getElementById('trShwRow3');

      if (trShwRow1) trShwRow1.style.display = '';
      if (trShwRow2) trShwRow2.style.display = '';
      if (trShwRow3) trShwRow3.style.display = '';
    }
  };

  // Migrated from VB: fn_HardLocks
  const fn_HardLocks = () => {
    if (tdHardLocksRef.current) {
      let html = "<b>HardLock(s)&nbsp;&nbsp;</b>";
      if (data.hardLocks && data.hardLocks.length > 0) {
        let str = '';
        data.hardLocks.forEach((lock: string, index: number) => {
          str += `${index + 1}) ${lock}<input id='chkHL${index}' type='checkbox' />&nbsp;&nbsp;&nbsp;&nbsp;`;
        });
        html += str;
      }
      tdHardLocksRef.current.innerHTML = html;
    }
  };

  // Migrated from VB: fn_tblCustHt
  const fn_tblCustHt = () => {
    if (tblCustomerRef.current && tdInstDatRef.current) {
      tblCustomerRef.current.style.height = `${tdInstDatRef.current.offsetHeight - 6}px`;
    }
  };

  // Migrated from VB: fn_SetGridSize
  const fn_SetGridSize = () => {
    if (SP_divScrollableTableRef.current) {
      const SPheight = (data.gridRowCnt * 36) + 70;
      SP_divScrollableTableRef.current.style.height = `${SPheight}px`;
      SP_divScrollableTableRef.current.style.width = `${gfn_GetClientWidth() - 35}px`;

      // Migrated from VB: window.setTimeout(SP_fn_Refresh, 100)
      setTimeout(() => {
        // In a real implementation, SP_fn_Refresh would refresh the grid
        // For this example, we don't need to implement it as we're using React's declarative rendering
      }, 100);
    }
  };

  // Migrated from VB: fn_Print
  const fn_Print = () => {
    if (divPrintRef.current) {
      divPrintRef.current.style.display = 'none';
      window.print();
      divPrintRef.current.style.display = '';
    }
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      // Collect all form data
      const formData = {
        ddCode: data.ddCode,
        installationCompleted: (document.getElementById('chkICY') as HTMLInputElement)?.checked || false,
        trainingProvided: (document.getElementById('chkTpY') as HTMLInputElement)?.checked || false,
        understandsUpload: (document.getElementById('chkUPY') as HTMLInputElement)?.checked || false,
        comments: data.comments,
        installerSignature: data.installerSignature,
        customerSignature: data.customerSignature,
        installerName: data.installerName,
        customerName: data.customerName,
        hardLocks: Array.from(document.querySelectorAll('#tdHardLocks input[type="checkbox"]:checked') as NodeListOf<HTMLInputElement>)
          .map((el) => el.id.replace('chkHL', '')),
        packages: Array.from(document.querySelectorAll('#SP_divScrollableTable input[type="checkbox"]:checked') as NodeListOf<HTMLInputElement>)
          .map((el) => el.id.replace('chkTick', ''))
      };

      const response = await fetch(`${API_BASE_URL}api/nskmapi/delivery-dockets/save/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) throw new Error('Failed to save delivery docket');

      const result = await response.json();
      if (result.success) {
        gfn_ShowMessage(result.message, 'A');
      } else {
        gfn_ShowMessage(result.error || 'Failed to save delivery docket', 'E');
      }
    } catch (err) {
      gfn_ShowMessage(err instanceof Error ? err.message : 'An error occurred', 'E');
    }
  };

  // Render the component
  return (
    <div style={{ margin: '1px', fontFamily: 'Arial, sans-serif' }}>
      {/* Print/Close Buttons */}
      <div id="divPrint" ref={divPrintRef} style={{ width: '98%' }}>
        <table width="100%" cellPadding="2" cellSpacing="0">
          <tbody>
            <tr>
              <td align="right">
                <input
                  id="btnPrint"
                  type="button"
                  value="Print"
                  onClick={fn_Print}
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt',
                    cursor: 'pointer'
                  }}
                />
                <input
                  id="btnClose"
                  type="button"
                  value="Close"
                  onClick={() => window.close()}
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt',
                    cursor: 'pointer',
                    marginLeft: '5px'
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Main Content */}
      <div style={{ width: '98%' }}>
        {/* Header Table */}
        <table width="100%" cellPadding="2" cellSpacing="0" style={{ paddingBottom: '0px' }}>
          <tbody>
            <tr>
              <td align="center" valign="top" id="tdImage" ref={tdImageRef} style={{ width: '25%' }}></td>
              <td align="center" valign="top" style={{ width: '55%', fontFamily: 'Arial, sans-serif', fontSize: '10pt', fontWeight: 'bold' }}>
                <br />
                Installation/Delivery Docket
                <br />
                Docket NO: &nbsp;{data.orderRef}
              </td>
              <td valign="top" align="left" id="tdTradName" ref={tdTradNameRef} style={{ width: '20%', fontFamily: 'Arial, sans-serif', fontSize: '8pt' }}></td>
            </tr>
          </tbody>
        </table>

        {/* Customer and Installation Details */}
        <table style={{ verticalAlign: 'top' }} width="100%" cellPadding="0" cellSpacing="0" border={0}>
          <tbody>
            <tr>
              <td id="tdCust" valign="top" style={{ width: '30%', borderBottom: '1px solid black' }}>
                <table
                  id="tblCustomer"
                  ref={tblCustomerRef}
                  cellPadding="2"
                  cellSpacing="0"
                  style={{
                    border: '1px solid black',
                    borderRightColor: 'white',
                    borderBottom: '1px solid white',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt',
                    fontWeight: 'bold',
                    verticalAlign: 'top',
                    paddingBottom: '0px',
                    width: '100%'
                  }}
                  border={0}
                >
                  <tbody>
                    <tr style={{ height: '100%' }}>
                      <td valign="top" align="left" style={{ height: '100%' }}>
                        <u>Customer:</u>
                        <br />
                        <br />
                        <strong>{data.strName}</strong>
                        <br />
                        {data.strAddress}
                        <br />
                        {data.capCity}&nbsp;{data.strPostCod}&nbsp;{data.strState}<br />
                        Ph.&nbsp;({data.strAreaCod}){data.strPhone}<br />
                        Mob.&nbsp;{data.mobPhNo}<br />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ borderTop: '1px solid black', paddingTop: '5px' }}>
                        <u>E-mail:</u>&nbsp;{data.email}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td id="tdInstDat" ref={tdInstDatRef} valign="top" style={{ width: '70%', border: '1px solid black' }}>
                <table
                  id="tblInstDt"
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt',
                    width: '100%',
                    height: '100%',
                    verticalAlign: 'top'
                  }}
                  cellPadding="2"
                  cellSpacing="0"
                  border={0}
                >
                  <tbody>
                    <tr>
                      <td align="center" colSpan={2} style={{
                        fontSize: '12pt',
                        fontWeight: 'bold',
                        backgroundColor: 'black',
                        color: 'white'
                      }}>
                        Install Date/Time: &nbsp;{data.instDate}&nbsp;&nbsp;&nbsp;{data.instTime}&nbsp;{data.instAMPM}
                      </td>
                      <td style={{ backgroundColor: 'black', borderRight: '1px solid black' }}>&nbsp;</td>
                    </tr>
                    <tr>
                      <td valign="top" align="left" colSpan={1} style={{ margin: '0', padding: '2px', width: '70%' }}>
                        &nbsp;
                        <div
                          dangerouslySetInnerHTML={{ __html: data.sGrid }}
                          style={{ fontFamily: 'Arial, sans-serif', fontSize: '10pt' }}
                        />
                      </td>
                      <td align="left" id="tdUIdPswd" ref={tdUIdPswdRef} valign="top" style={{ width: '30%' }}>
                        &nbsp;
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        {/* Hidden Rows (migrated from VB) */}
        <table width="100%" cellPadding="3" cellSpacing="0" style={{ fontFamily: 'Arial, sans-serif', fontSize: '12pt' }}>
          <tbody>
            <tr id="trShwRow1" style={{ display: 'none' }}>
              <td style={{ width: '20%' }}>&nbsp;</td>
              <td style={{ width: '30%' }}>&nbsp;</td>
              <td style={{ width: '30%' }}>&nbsp;</td>
              <td style={{ width: '20%' }}></td>
            </tr>
            <tr id="trShwRow2" style={{ display: 'none' }}>
              <td style={{ width: '20%' }}>&nbsp;</td>
              <td style={{ width: '30%' }}>&nbsp;</td>
              <td style={{ width: '30%' }}>&nbsp;</td>
              <td style={{ width: '20%' }}></td>
            </tr>
            <tr id="trShwRow3" style={{ display: 'none' }}>
              <td style={{ width: '20%' }}>&nbsp;</td>
              <td style={{ width: '30%' }}>&nbsp;</td>
              <td style={{ width: '30%' }}>&nbsp;</td>
              <td style={{ width: '20%' }}></td>
            </tr>
          </tbody>
        </table>

        {/* Package Grid */}
        <table width="100%" cellPadding="2" cellSpacing="0">
          <tbody>
            <tr>
              <td>
                <div
                  id="SP_divScrollableTable"
                  ref={SP_divScrollableTableRef}
                  style={{
                    overflow: 'auto',
                    border: '1px solid #ccc'
                  }}
                  dangerouslySetInnerHTML={{ __html: data.pGrid }}
                />
              </td>
            </tr>
          </tbody>
        </table>

        {/* Checkboxes Table */}
        <table width="100%" cellPadding="3" cellSpacing="0" style={{ fontFamily: 'Arial, sans-serif', fontSize: '10pt' }}>
          <tbody>
            <tr>
              <td colSpan={3} align="left" id="tdHardLocks" ref={tdHardLocksRef}></td>
            </tr>
            <tr>
              <td align="left" style={{ width: '60%' }}>Installation completed</td>
              <td align="left" style={{ width: '20%' }}>
                <b>Yes</b><input id="chkICY" type="checkbox" defaultChecked={data.installationCompleted} />
              </td>
              <td align="left" style={{ width: '20%' }}>
                <b>No</b><input id="chkICN" type="checkbox" defaultChecked={!data.installationCompleted} />
              </td>
            </tr>
            <tr>
              <td align="left" style={{ width: '60%' }}>Training provided</td>
              <td align="left" style={{ width: '20%' }}>
                <b>Yes</b><input id="chkTpY" type="checkbox" defaultChecked={data.trainingProvided} />
              </td>
              <td align="left" style={{ width: '20%' }}>
                <b>No</b><input id="chkTPN" type="checkbox" defaultChecked={!data.trainingProvided} />
              </td>
            </tr>
            <tr>
              <td align="left" style={{ width: '60%' }}>
                I understand how to upload my progress reports and send it to the Tutor Support Team.
              </td>
              <td align="left" style={{ width: '20%' }}>
                <b>Yes</b><input id="chkUPY" type="checkbox" defaultChecked={data.understandsUpload} />
              </td>
              <td align="left" style={{ width: '20%' }}>
                <b>No</b><input id="chkUPN" type="checkbox" defaultChecked={!data.understandsUpload} />
              </td>
            </tr>
            <tr>
              <td align="left" colSpan={3}>
                Comments: <input
                  type="text"
                  style={{
                    width: '100%',
                    border: 'none',
                    borderBottom: '1px solid black',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt'
                  }}
                  value={data.comments}
                  onChange={(e) => setData({ ...data, comments: e.target.value })}
                />
              </td>
            </tr>
          </tbody>
        </table>

        {/* Signatures Table */}
        <table width="100%" cellPadding="3" cellSpacing="0" style={{ fontFamily: 'Arial, sans-serif', fontSize: '10pt' }}>
          <tbody>
            <tr style={{ height: '75px' }}>
              <td align="left" style={{ width: '16%' }}><b>Installer's Signature:</b></td>
              <td align="left" style={{ width: '34%' }}>
                <input
                  type="text"
                  style={{
                    width: '100%',
                    border: 'none',
                    borderBottom: '1px solid black',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt'
                  }}
                  value={data.installerSignature}
                  onChange={(e) => setData({ ...data, installerSignature: e.target.value })}
                />
              </td>
              <td align="left" style={{ width: '16%' }}><b>Customer's Signature:</b></td>
              <td align="left" style={{ width: '34%' }}>
                <input
                  type="text"
                  style={{
                    width: '100%',
                    border: 'none',
                    borderBottom: '1px solid black',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt'
                  }}
                  value={data.customerSignature}
                  onChange={(e) => setData({ ...data, customerSignature: e.target.value })}
                />
              </td>
            </tr>
            <tr>
              <td align="left" style={{ width: '16%', paddingBottom: '3px' }}><b>Print Name:</b></td>
              <td align="left" style={{ width: '34%', paddingBottom: '3px' }}>
                <input
                  type="text"
                  style={{
                    width: '100%',
                    border: 'none',
                    borderBottom: '1px solid black',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt'
                  }}
                  value={data.installerName}
                  onChange={(e) => setData({ ...data, installerName: e.target.value })}
                />
              </td>
              <td align="left" style={{ width: '16%', paddingBottom: '3px' }}><b>&nbsp;</b></td>
              <td align="left" style={{ width: '34%', paddingBottom: '3px' }}>
                <input
                  type="text"
                  style={{
                    width: '100%',
                    border: 'none',
                    borderBottom: '1px solid black',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '10pt'
                  }}
                  value={data.customerName}
                  onChange={(e) => setData({ ...data, customerName: e.target.value })}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={4} style={{ fontFamily: 'Arial, sans-serif', fontSize: '10pt' }}>
                {data.strFax}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Hidden Fields (migrated from VB) */}
      <input type="hidden" id="hidCountryCode" value={data.countryCode} />
      <input type="hidden" id="hidTradName" value={data.tradingName} />
      <input type="hidden" id="hidDaddr1" value={data.dAddr1} />
      <input type="hidden" id="hidDaddr2" value={data.dAddr2} />
      <input type="hidden" id="hidPhone" value={data.phone} />
      <input type="hidden" id="hidFax" value={data.fax} />
      <input type="hidden" id="hidABNo" value={data.abnNo} />
      <input type="hidden" id="hidLoginId" value={data.loginId} />
      <input type="hidden" id="hidPswd" value={data.password} />
      <input type="hidden" id="hiGridRowCnt" value={data.gridRowCnt} />
      <input type="hidden" id="hidMaxCnt" value={data.maxCount} />
      <input type="hidden" id="hidHLocks" value={data.hardLocks?.join(',') || ''} />
      <input type="hidden" id="hidStrHL" value="" />
    </div>
  );
};

export default KMSalesDeliveryDockets;